import { LIFESTYLE, TIMELINE, CORE_VALUES } from "@/data/products";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative bg-neutral-950 text-white pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img src={LIFESTYLE.factory} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/40 to-neutral-950" />
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="eyebrow text-gold-400 mb-4">About SBC Ltd</div>
          <h1 className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Manchester roots.<br /><span className="gold-gradient-text">Global thirst.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-neutral-300 leading-relaxed">
            Scitygate Brewing Company Ltd (Company No. 17323558) is a UK-registered beverage company incorporated on 6 July 2026. Based in Manchester, United Kingdom, SBC Ltd is developing a portfolio of five beverage brands — Maltora, OneCola, VoltX, OneFresh and OneSpring — for the UK and international markets.
          </p>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12">
          <div className="space-y-6">
            <div className="eyebrow">Our Story</div>
            <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-tight">A UK beverage startup with global ambition.</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Scitygate Brewing Company Ltd (SBC Ltd) is a UK-registered beverage company incorporated in July 2026. Based in Manchester, United Kingdom, the company is developing a portfolio of beverage brands, including Maltora, OneCola, VoltX, OneFresh and OneSpring.</p>
              <p>SBC Ltd is focused on product development, brand innovation, manufacturing partnerships and building distribution opportunities across the United Kingdom and international markets.</p>
              <p>Our vision is to develop distinctive, high-quality beverage brands that serve diverse consumers and create long-term business opportunities.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src={LIFESTYLE.factory} alt="Factory" className="rounded-2xl aspect-[3/4] object-cover w-full" />
            <img src={LIFESTYLE.lab} alt="Lab" className="rounded-2xl aspect-[3/4] object-cover w-full mt-8" />
            <img src={LIFESTYLE.team} alt="Team" className="rounded-2xl aspect-[3/4] object-cover w-full -mt-4" />
            <img src={LIFESTYLE.bottling} alt="Bottling" className="rounded-2xl aspect-[3/4] object-cover w-full mt-4" />
          </div>
        </div>
      </section>

      <section className="py-24 bg-muted/40">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="eyebrow">Milestones</div>
            <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter mt-2">Our journey so far</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {TIMELINE.map((t) => (
              <div key={`${t.year}-${t.title}`} className="p-6 rounded-2xl bg-background border border-border">
                <div className="font-display font-black text-3xl gold-gradient-text">{t.year}</div>
                <div className="font-semibold mt-2">{t.title}</div>
                <p className="text-sm text-muted-foreground mt-2">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="eyebrow">Core Values</div>
            <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter mt-2">The principles that define us</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {CORE_VALUES.map((v, i) => (
              <div key={v.title} className="p-6 rounded-2xl border border-border">
                <div className="text-[10px] uppercase tracking-widest text-gold-500 font-bold">0{i+1}</div>
                <div className="font-display font-bold text-lg mt-2">{v.title}</div>
                <p className="text-xs text-muted-foreground mt-2">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
